/* Démo animée du générateur : rejoue le vrai parcours en boucle quand elle est visible. */
(function () {
  var d = document.getElementById("k2-demo");
  if (!d) return;
  // La classe « brand » existe aussi sur le site (logo du menu) : on garde la mise en page de la démo.
  d.style.display = "block";
  var q = function (s) { return d.querySelector(s); }, qa = function (s) { return Array.prototype.slice.call(d.querySelectorAll(s)); };
  var pill = q(".k2-pill"), cur = q(".k2-cursor"), steps = qa(".k2-step"), pn = q(".k2-pn"), pb = q(".k2-pb i");
  var heads = qa(".k2-h"), ctas = qa(".k2-c"), tabs = qa(".k2-tab"), tiles = qa(".k2-t"), out = q(".k2-out"), cn = q(".k2-cn");
  var H = [d.dataset.h1, d.dataset.h2], C = [d.dataset.c1, d.dataset.c2];
  var visible = false;
  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var waitVisible = function () { return new Promise(function (r) { (function c() { visible && !document.hidden ? r() : setTimeout(c, 300); })(); }); };
  var setText = function (h, c) { heads.forEach(function (e) { e.textContent = h; }); ctas.forEach(function (e) { e.textContent = c; }); };
  var photo = function (st) { d.style.setProperty("--k2-photo", "var(--k2-" + st + ")"); };

  function moveTo(el, fx, fy) {
    var r = el.getBoundingClientRect(), b = d.getBoundingClientRect();
    cur.style.transform = "translate(" + (r.left - b.left + r.width * (fx || 0.55)) + "px," + (r.top - b.top + r.height * (fy || 0.55)) + "px)";
  }
  async function click(el) {
    cur.classList.remove("click"); void cur.offsetWidth; cur.classList.add("click");
    if (el) { el.classList.add("press"); await sleep(140); el.classList.remove("press"); } else await sleep(140);
  }
  async function go(el, wait, fx, fy) { moveTo(el, fx, fy); await sleep(wait || 650); await click(el); }
  async function type(el, live) {
    var s = el.querySelector("span"), t = el.getAttribute("data-type");
    el.classList.add("typing");
    for (var k = 1; k <= t.length; k++) { s.textContent = t.slice(0, k); if (live) setText(t.slice(0, k), C[0]); await sleep(48); }
    await sleep(260); el.classList.remove("typing");
  }
  function turnAll(h, c) {
    return new Promise(function (done) {
      tiles.forEach(function (t, i) {
        setTimeout(function () {
          t.classList.remove("turn"); void t.offsetWidth; t.classList.add("turn");
          setTimeout(function () {
            t.querySelector(".k2-h").textContent = h; t.querySelector(".k2-c").textContent = c;
          }, 280);
          setTimeout(function () { t.classList.remove("turn"); if (i === tiles.length - 1) done(); }, 580);
        }, i * 75);
      });
      // L'aperçu (caché) garde le même texte
      heads[0].textContent = h; ctas[0].textContent = c;
    });
  }
  function setTab(i) {
    tabs.forEach(function (t, k) { t.classList.toggle("on", k === i); });
    var t = tabs[i];
    pill.style.width = t.offsetWidth + "px";
    pill.style.transform = "translateX(" + t.offsetLeft + "px)";
  }
  function open(n) {
    steps.forEach(function (s, i) { s.classList.toggle("is-open", i === n - 1); if (i < n - 1) s.classList.add("is-done"); });
    pn.textContent = n; pb.style.width = (n * 20) + "%";
  }
  function reset() {
    d.className = "k2"; photo("studio"); setText("", "");
    steps.forEach(function (s) { s.classList.remove("is-open", "is-done"); });
    qa(".k2-in[data-type] > span").forEach(function (s) { s.textContent = ""; });
    qa(".k2-li,.k2-chip[data-c],.k2-sty,.k2-plat").forEach(function (e) { e.classList.remove("on"); });
    setTab(0);
    open(1);
  }
  function final() {
    reset(); steps.forEach(function (s) { s.classList.add("is-done"); s.classList.remove("is-open"); });
    pb.style.width = "100%"; pn.textContent = 5; photo("pop"); setText(H[0], C[0]);
    d.classList.add("brand", "ready", "res", "settled");
  }
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) { final(); return; }

  async function run() {
    for (;;) {
      await waitVisible();
      reset(); cur.style.opacity = 1; await sleep(500);
      // 1. Le site est analysé
      var site = q('[data-k="site"]');
      await go(site, 700); await type(site);
      await go(q(".k2-mbtn"), 500);
      d.classList.add("scanning");
      var li = qa(".k2-li");
      for (var i = 0; i < li.length; i++) { await sleep(420); li[i].classList.add("on"); }
      await sleep(300); d.classList.remove("scanning"); d.classList.add("found", "brand");
      await sleep(900);
      // 2. L'accroche s'écrit en direct dans l'aperçu
      open(2); await sleep(350);
      var head = q('[data-k="head"]');
      await go(head, 600); await type(head, true);
      await sleep(400);
      // 3. Langues
      open(3); await sleep(350);
      var chips = qa(".k2-chip[data-c]");
      for (var c = 0; c < chips.length; c++) { await go(chips[c], 520); chips[c].classList.add("on"); }
      await sleep(350);
      // 4. Ambiance : l'aperçu change de photo
      open(4); await sleep(350);
      var sts = qa(".k2-sty");
      for (var s = 0; s < sts.length; s++) {
        await go(sts[s], s ? 500 : 650);
        sts.forEach(function (e) { e.classList.remove("on"); }); sts[s].classList.add("on");
        photo(sts[s].getAttribute("data-st")); await sleep(450);
      }
      // 5. Plateformes
      open(5); await sleep(350);
      var pl = qa(".k2-plat");
      for (var p = 0; p < pl.length; p++) { await go(pl[p], 520); pl[p].classList.add("on"); }
      d.classList.add("ready"); await sleep(250);
      // Génération puis résultats
      await go(q(".k2-go"), 650);
      steps[4].classList.add("is-done"); steps[4].classList.remove("is-open");
      d.classList.add("gen"); await sleep(1900);
      cur.style.opacity = 0;
      // La pub de l'aperçu éclate en formats : chaque vignette part du centre.
      var ob = out.getBoundingClientRect();
      tiles.forEach(function (t) {
        var r = t.getBoundingClientRect();
        t.style.setProperty("--tx", (ob.left + ob.width / 2 - (r.left + r.width / 2)).toFixed(0) + "px");
        t.style.setProperty("--ty", (ob.top + ob.height / 2 - (r.top + r.height / 2)).toFixed(0) + "px");
      });
      d.classList.add("res"); d.classList.remove("gen");
      for (var n = 1; n <= 11; n++) { cn.textContent = n; await sleep(70); }
      await sleep(1000); d.classList.add("settled"); setTab(0); await sleep(1600); d.classList.add("toastout");
      // Les langues défilent : chaque pub se retourne à son tour, le texte change à mi-course
      for (var l = 1; l <= 2; l++) {
        var li2 = l % 2;
        setTab(li2);
        await turnAll(H[li2], C[li2]);
        await sleep(l < 2 ? 2400 : 1500);
      }
      d.classList.add("fade"); await sleep(450);
    }
  }
  if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(d);
  else visible = true;
  run();
})();
